module.exports = __webpack_public_path__ + "img/official-qrcode.adc17f97.png";